// Imports
import planMapping from './plan-mapping';
import isValidSubscriptionSize from './is-valid-subscription-size';


/** Shareable to determine monthly allotments of SMS credits for a subscription at a given size */
export default function determineMonthlySMSCreditAllotment(options: {
	plan: (typeof planMapping)[keyof typeof planMapping];
	size: number;
}) {
	// Handle unsupported plans
	if (options.plan === planMapping.free || options.plan === planMapping.inform) {
		return 0;
	}
	
	
	// Verify size
	if (!isValidSubscriptionSize(options)) {
		throw new Error(`Unexpected website size: ${options.size}`);
	}
	
	
	// Handle Deluxe plan
	if (options.plan === planMapping.deluxe) {
		return {
			5000: 2500,
			2500: 2000,
			1000: 1500,
			500: 1000,
			300: 600,
			200: 400,
			125: 250,
			75: 150,
			50: 100,
			25: 50,
			15: 10, // Trials
			65535: 100, // Big data
			9999: 1500, // Legacy Deluxe plan
		}[options.size] as number;
	}
	
	
	// Handle all other plans
	return options.size * 2;
}
